module.exports = __webpack_public_path__ + "img/ppp.151bd670.svg";